module.exports = __webpack_public_path__ + "img/sellingh.3f86fdc2.jpg";